"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOnboardingStatus = void 0;
/**
 * The different statuses a user's onboarding can have.
 */
var UserOnboardingStatus;
(function (UserOnboardingStatus) {
    /**
     * The onboarding has been started by the user.
     */
    UserOnboardingStatus["STARTED"] = "STARTED";
    /**
     * The onboarding has been submitted by the user.
     * At this point, the onboarding is no longer editable by the user and is awaiting validation.
     */
    UserOnboardingStatus["SUBMITTED"] = "SUBMITTED";
    /**
     * The onboarding has been accepted by Leavy.
     * The user is now a Happy Leaver and/or a Host on Demand.
     */
    UserOnboardingStatus["ACCEPTED"] = "ACCEPTED";
    /**
     * The onboarding has been rejected by Leavy.
     * The user can eventually restart his onboarding.
     */
    UserOnboardingStatus["REJECTED"] = "REJECTED";
})(UserOnboardingStatus = exports.UserOnboardingStatus || (exports.UserOnboardingStatus = {}));
//# sourceMappingURL=UserOnboardingStatus.js.map